// tslint:disable: max-line-length

export class FormioConfig {
}

export const AppConfig = {};
export const EditForm = [
  { key: 'type', type: 'hidden' },
  {
    type: 'textfield',
    input: true,
    key: 'label',
    hint: '',
    tooltip: '',
    value: '',
    label: 'Rótulo *',
    validate: {
      required: true
    },
    size: 255
  },
  {
    type: 'textfield',
    input: true,
    key: 'placeholder',
    value: '',
    label: 'Placeholder',
    placeholder: 'Placehoder'
  },
  {
    type: 'select',
    input: true,
    key: 'labelPosition',
    value: 'top',
    options: [
      { name: 'Em cima', value: 'top' },
      { name: 'Embaixo', value: 'bottom' }
    ],
    label: 'Posição do rótulo'
  },
  {
    type: 'select',
    input: true,
    key: 'case',
    value: 'mixed',
    options: [
      { name: 'Nenhum', value: 'mixed' },
      { name: 'Maiúsculo', value: 'uppercase' },
      { name: 'Minúsculo', value: 'lowercase' },
    ],
    label: 'Transformar texto'
  },
  {
    type: 'textfield',
    input: true,
    key: 'description',
    value: '',
    label: 'Descrição'
  },
  {
    type: 'textarea',
    input: true,
    key: 'tooltip',
    value: '',
    label: 'Dica'
  },
  {
    type: 'textfield',
    input: true,
    key: 'inputMask',
    value: '',
    tooltip: '\n        Uma máscara ajuda o usuário a digitar em um formato, garantindo um padrão predefinido.\n        \n        9 = numérico\n        a = alfabético\n        * = alfanumérico\n        \n        Exemplo de máscara telefônica: \n(99) 99999-9999',
    label: 'Máscara'
  },
  {
    type: 'textfield',
    input: true,
    key: 'suffix',
    value: '',
    label: 'Sufixo'
  },
  {
    type: 'textfield',
    input: true,
    key: 'prefix',
    value: '',
    label: 'Prefixo'
  },
  {
    type: 'textfield',
    input: true,
    key: 'customClass',
    value: '',
    label: 'Classe CSS',
    tooltip: 'Defina uma classe customizada para esse elemento'
  },
  {
    type: 'toogle',
    input: true,
    label: 'Desabilitar',
    tooltip: '',
    key: 'disabled'
  },
  {
    type: 'toogle',
    input: true,
    label: 'Esconder',
    key: 'hidde'
  },
  {
    type: 'toogle',
    input: true,
    label: 'Esconder rótulo',
    key: 'hideLabel'
  },
  {
    type: 'toogle',
    input: true,
    label: 'Opção de copiar',
    key: 'copy'
  }
];

export const SelectEditForm = [
  {
    type: 'textfield',
    input: true,
    key: 'label',
    hint: '',
    tooltip: '',
    value: '',
    label: 'Rótulo',
    validate: {
      required: true
    },
    size: 255,
  },
  {
    type: 'textfield',
    input: true,
    key: 'placeholder',
    value: '',
    label: 'Placeholder',
    placeholder: 'Placehoder'
  },
  {
    type: 'select',
    input: true,
    key: 'labelPosition',
    value: 'top',
    options: [
      { name: 'Em cima', value: 'top' },
      { name: 'Embaixo', value: 'bottom' }
    ],
    label: 'Posição do rótulo'
  },
  {
    type: 'textfield',
    input: true,
    key: 'description',
    value: '',
    label: 'Descrição'
  },
  {
    type: 'textarea',
    input: true,
    key: 'tooltip',
    value: '',
    label: 'Dica'
  },
  {
    type: 'textfield',
    input: true,
    key: 'customClass',
    value: '',
    label: 'Classe CSS',
    tooltip: 'Defina uma classe customizada para esse elemento'
  },
  {
    type: 'toogle',
    input: true,
    label: 'Desabilitar',
    tooltip: '',
    key: 'disabled'
  },
  {
    type: 'toogle',
    input: true,
    label: 'Esconder',
    key: 'hidde'
  },
  {
    type: 'toogle',
    input: true,
    label: 'Esconder rótulo',
    key: 'hideLabel'
  }
];
export const SelectWidget = {
  searchPlaceholderValue: 'Digite para procurar',
  loadingText: 'Carregando...',
  noResultsText: 'Sem resultados encontrados',
  noChoicesText: 'Sem resultados',
  itemSelectText: 'Clique para selecionar',
  addItemText: '',
  maxItemText: ''
};

export const ContentEditForm = [
  {
    type: 'textfield',
    input: true,
    key: 'label',
    hint: '',
    tooltip: '',
    value: '',
    label: 'Rótulo',
    focus: true,
    validate: { required: true },
    size: 255
  },
  {
    type: 'toogle',
    input: true,
    label: 'Esconder',
    key: 'hidde'
  },
  {
    type: 'textfield',
    input: true,
    key: 'customClass',
    value: '',
    label: 'Classe CSS',
    tooltip: 'Defina uma classe customizada para esse elemento'
  },
  {
    type: 'editor',
    input: true,
    key: 'html',
    hint: '',
    tooltip: '',
    value: '',
    label: '',
    validate: { required: true }
  }
];

export const RadioEditForm = [
  {
    type: 'textfield',
    input: true,
    key: 'label',
    hint: '',
    tooltip: '',
    value: '',
    label: 'Rótulo',
    validate: {
      required: true
    },
    size: 255
  },
  {
    type: 'select',
    input: true,
    key: 'labelPosition',
    value: 'top',
    options: [
      { name: 'Em cima', value: 'top' },
      { name: 'Embaixo', value: 'bottom' }
    ],
    label: 'Posição do rótulo'
  },
  {
    type: 'select',
    input: true,
    key: 'optionsLabelPosition',
    value: 'right',
    options: [
      { name: 'Em cima', value: 'top' },
      { name: 'Embaixo', value: 'bottom' },
      { name: 'Direita', value: 'right' },
      { name: 'Esquerda', value: 'left' }
    ],
    label: 'Posição do rótulo das opções'
  },
  {
    type: 'textfield',
    input: true,
    key: 'description',
    value: '',
    label: 'Descrição'
  },
  {
    type: 'textarea',
    input: true,
    key: 'tooltip',
    value: '',
    label: 'Dica'
  },
  {
    type: 'textfield',
    input: true,
    key: 'customClass',
    value: '',
    label: 'Classe CSS',
    tooltip: 'Defina uma classe customizada para esse elemento'
  },
  {
    type: 'toogle',
    input: true,
    label: 'Disposição em linha',
    key: 'inline'
  },
  {
    type: 'toogle',
    input: true,
    label: 'Desabilitar',
    tooltip: '',
    key: 'disabled'
  },
  {
    type: 'toogle',
    input: true,
    label: 'Esconder',
    key: 'hidde'
  },
  {
    type: 'toogle',
    input: true,
    label: 'Esconder rótulo',
    key: 'hideLabel'
  }
];

export const NumberEditForm = [
  {
    type: 'textfield',
    input: true,
    key: 'label',
    hint: '',
    tooltip: '',
    value: '',
    label: 'Rótulo',
    validate: {
      required: true
    },
    size: 255
  },
  {
    type: 'textfield',
    input: true,
    key: 'placeholder',
    value: '',
    label: 'Placeholder',
    placeholder: 'Placehoder'
  },
  {
    type: 'select',
    input: true,
    key: 'labelPosition',
    value: 'top',
    options: [
      { name: 'Em cima', value: 'top' },
      { name: 'Embaixo', value: 'bottom' }
    ],
    label: 'Posição do rótulo'
  },
  {
    type: 'textfield',
    input: true,
    key: 'description',
    value: '',
    label: 'Descrição'
  },
  {
    type: 'textarea',
    input: true,
    key: 'tooltip',
    value: '',
    label: 'Dica'
  },
  {
    type: 'number',
    input: true,
    key: 'decimalLimit',
    value: '',
    label: 'Limite de decimais'
  },
  {
    type: 'toogle',
    input: true,
    label: 'Requerer decimal',
    key: 'requireDecimal'
  },
  {
    type: 'textfield',
    input: true,
    key: 'suffix',
    value: '',
    label: 'Sufixo'
  },
  {
    type: 'textfield',
    input: true,
    key: 'prefix',
    value: '',
    label: 'Prefixo'
  },
  {
    type: 'textfield',
    input: true,
    key: 'customClass',
    value: '',
    label: 'Classe CSS',
    tooltip: 'Defina uma classe customizada para esse elemento'
  },
  {
    type: 'toogle',
    input: true,
    label: 'Desabilitar',
    tooltip: '',
    key: 'disabled'
  },
  {
    type: 'toogle',
    input: true,
    label: 'Esconder',
    key: 'hidde'
  },
  {
    type: 'toogle',
    input: true,
    label: 'Esconder rótulo',
    key: 'hideLabel'
  }
];

export const DateTimeEditForm = [
  { key: 'type', type: 'hidden' },
  {
    type: 'textfield',
    input: true,
    key: 'label',
    hint: '',
    tooltip: '',
    value: '',
    label: 'Rótulo',
    validate: {
      required: true
    },
    size: 255
  },
  {
    type: 'textfield',
    input: true,
    key: 'format',
    value: '',
    label: 'Formato',
    placeholder: 'dd-MM-yyyy'
  },
  {
    type: 'textfield',
    input: true,
    key: 'placeholder',
    value: '',
    label: 'Placeholder',
    placeholder: 'Placehoder'
  },
  {
    type: 'select',
    input: true,
    key: 'labelPosition',
    value: 'top',
    options: [
      { name: 'Em cima', value: 'top' },
      { name: 'Embaixo', value: 'bottom' }
    ],
    label: 'Posição do rótulo'
  },
  {
    type: 'textfield',
    input: true,
    key: 'description',
    value: '',
    label: 'Descrição'
  },
  {
    type: 'textarea',
    input: true,
    key: 'tooltip',
    value: '',
    label: 'Dica'
  },
  {
    type: 'textfield',
    input: true,
    key: 'suffix',
    value: '',
    label: 'Sufixo'
  },
  {
    type: 'textfield',
    input: true,
    key: 'prefix',
    value: '',
    label: 'Prefixo'
  },
  {
    type: 'textfield',
    input: true,
    key: 'customClass',
    value: '',
    label: 'Classe CSS',
    tooltip: 'Defina uma classe customizada para esse elemento'
  },
  {
    type: 'toogle',
    input: true,
    label: 'Desabilitar',
    tooltip: '',
    key: 'disabled'
  },
  {
    type: 'toogle',
    input: true,
    label: 'Esconder',
    key: 'hidde'
  },
  {
    type: 'toogle',
    input: true,
    label: 'Esconder rótulo',
    key: 'hideLabel'
  }
];

export const DateTimeWidget = {
  type: 'calendar',
  displayInTimezone: 'viewer',
  language: 'pt',
  useLocaleSettings: false,
  allowInput: true,
  mode: 'single',
  enableTime: true,
  noCalendar: false,
  format: 'dd/MM/yyyy',
  hourIncrement: 1,
  minuteIncrement: 1,
  time_24hr: true
};

export const ContainerEditForm = [
  {
    type: 'toogle',
    input: true,
    label: 'Desabilitar',
    tooltip: '',
    key: 'disabled'
  },
  {
    type: 'toogle',
    input: true,
    label: 'Esconder',
    key: 'hidde'
  },
];
